// extracted by mini-css-extract-plugin
export var text = "_redotech-redo-web-src-arbiter-components-common-descriptors-text";